import { TopBar } from "@/Topbar/TopBar";
import { Button } from "@/design-system/components/Button/Button";
import { signout } from "@/NavBar/signout";
import inviteInvalidImage from "@/img/invite_is_invalid.png";
import { AcceptInvitePageWrapper } from "./utils";
import { InvalidInviteProps } from "./types";

const [, wrongEmail, inviteExpired, inviteAlreadyAccepted] = [0, 1, 2, 3];

export function InvalidInvitePage({ reason, details }: InvalidInviteProps) {
  let reasonString: string;

  if (reason === wrongEmail) {
    reasonString =
      "Reason: You are signed in with a different email than the one the invite was sent to.";
  } else if (reason === inviteExpired) {
    reasonString = "Reason: The invite has expired.";
  } else if (reason === inviteAlreadyAccepted) {
    reasonString = "Reason: The invite has already been accepted";
  } else {
    reasonString = "Please contact support@freshpaint.io";
  }

  return (
    <>
      <TopBar includeLogo />
      <AcceptInvitePageWrapper>
        <img alt="" src={inviteInvalidImage} />
        <h1>Error: Invalid Invite</h1>
        <p>{reasonString}</p>
        {reason === wrongEmail && <p>{details}</p>}
        <div className="flex gap-4">
          {reason === wrongEmail && (
            <Button variant="secondary" onClick={() => signout()}>
              Switch Email
            </Button>
          )}
          <Button
            onClick={() => (window.location.href = "https://freshpaint.io")}
          >
            Back to Home
          </Button>
        </div>
      </AcceptInvitePageWrapper>
    </>
  );
}
